// extracted by mini-css-extract-plugin
export default {"contendormodal":"ventanamodal_contendormodal__LBTSP","overlay":"ventanamodal_overlay__RMclK","overlayNone":"ventanamodal_overlayNone__oS-3Y","cerrar":"ventanamodal_cerrar__AkWIy"};